import { AxiosResponse } from "axios";
import { getData } from "./apiInstance";
import {
  GetSchedulingNotificationCountPayloadType,
  GetSchedulingNotificationPayloadType,
} from "../commonTypes/notificationType";

export async function getSchedulingNotificationApi(
  data: GetSchedulingNotificationPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset } = data;
  return await getData(`notification-module/finac/notification/list`, {
    // return await (getData(`notification-module/scheduling/notification/list`, {
    params: {
      limit,
      offset,
    },
    headers: {
      "Content-type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSchedulingNotificationCountApi(
  data: GetSchedulingNotificationCountPayloadType
): Promise<AxiosResponse> {
  const { token } = data;
  return await getData(`notification-module/finac/notification/count`, {
    headers: {
      "Content-type": "application/json",
      "user-token": token,
    },
  });
}
